import React, { useState, useRef, useEffect, useContext } from "react";
import {
  Popper,
  Grow,
  ClickAwayListener,
  Paper,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  TableCell,
  TableRow,
  IconButton,
} from "@material-ui/core";
import { Context as PortalContext } from "../context/portal.context";
// import PrintIcon from "@material-ui/icons/Print";
// import DownloadIcon from "@material-ui/icons/GetApp";
// import EyeIcon from "@material-ui/icons/Visibility";
// import MoreIcon from "@material-ui/icons/MoreHoriz";
import Thousands from "../helpers/Thousands";
import { format } from "date-fns";

import PaymentMethod from "../helpers/PaymentMethod";

const MyTableRow = (props) => {
  const [open] = useState(false);
  const [rowMenuOpen, setRowMenuOpen] = useState(false);
  const { state } = useContext(PortalContext);
  const anchorRef = useRef(null);

  const prevOpen = useRef(rowMenuOpen);

  const isSelected = (date) => props.selected.indexOf(date) !== -1;

  const isItemSelected = isSelected(props.row);
  const labelId = `enhanced-table-checkbox-${props.index}`;

  useEffect(() => {
    if (prevOpen.current === true && rowMenuOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = rowMenuOpen;
  }, [rowMenuOpen]);

  const handleToggle = () => {
    setRowMenuOpen((prevOpen) => !prevOpen);
  };

  const handleCloseRowMenu = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setRowMenuOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setRowMenuOpen(false);
    }
  }

  const handleMenuItemClick = (event, row) => {
    setRowMenuOpen(false);
    props.handleOpenModal();
  };

  const handleClick = (event, row) => {
    const selectedIndex = props.selected.findIndex((i) => i.date === row.date);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(props.selected.slice(1));
    } else if (selectedIndex === props.selected.length - 1) {
      newSelected = newSelected.concat(props.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        props.selected.slice(0, selectedIndex),
        props.selected.slice(selectedIndex + 1)
      );
    }

    props.setSelected(newSelected);
    props.setPaymentTotal(props.setTotal(newSelected));
  };

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={props.row.date}
      selected={isItemSelected}
      style={{ position: "relative" }}
    >
      <TableCell component="th" id={labelId} scope="row" size="medium">
        {props.row.paymentID}
      </TableCell>
      <TableCell component="th" id={labelId} scope="row">
        {props.row.status}
      </TableCell>
      <TableCell component="th" id={labelId} scope="row">
        {props.row.paymentDate}
      </TableCell>
      <TableCell component="th" id={labelId} scope="row">
        {props.row.invoices}
      </TableCell>

      {/* <TableCell align="left">{props.row.description}</TableCell> */}
      <TableCell align="left" style={{ fontWeight: "bold" }}>
        {Thousands(props.row.amount)}
      </TableCell>
      {state.invoice_interface !== "amount" && (
        <TableCell align="left">{props.row.fee}</TableCell>
      )}

      <TableCell align="left">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {PaymentMethod(props.row.paymentMethod.paymentMethod, 20)}
          &nbsp;&nbsp;&nbsp;&nbsp;
          {props.row.paymentMethod.paymentLastFour
            ? `...${props.row.paymentMethod.paymentLastFour}`
            : "-"}
        </div>
      </TableCell>

      {/* <TableCell align="right" ref={anchorRef}>
        <IconButton onClick={handleToggle}>
          <MoreIcon />
        </IconButton>
        <Popper
          open={rowMenuOpen}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          style={{ zIndex: 10000000 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper style={{ width: 250 }} elevation={5}>
                <ClickAwayListener onClickAway={handleCloseRowMenu}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={handleMenuItemClick}>
                      <ListItemIcon>
                        <EyeIcon />
                      </ListItemIcon>
                      <ListItemText primary="View Invoice" />
                    </MenuItem>
                    <MenuItem onClick={handleMenuItemClick}>
                      <ListItemIcon>
                        <PrintIcon />
                      </ListItemIcon>
                      <ListItemText primary="Print Invoice" />
                    </MenuItem>
                    <MenuItem onClick={handleMenuItemClick}>
                      <ListItemIcon>
                        <DownloadIcon />
                      </ListItemIcon>
                      <ListItemText primary="Download PDF" />
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </TableCell> */}
    </TableRow>
  );
};

export default MyTableRow;
